import React from "react";
import GlobalStyles from "@mui/material/GlobalStyles";

/**
 * Drives the page-change animation and the card -> detail-page "morph"
 * effect, both powered by the browser's native View Transitions API
 * (https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API).
 *
 * Route changes triggered with `viewTransition` (on <Link> / navigate())
 * pick these up automatically. Elements sharing a `view-transition-name`
 * (e.g. a service card's image/title and the matching element on its
 * detail page) animate smoothly between their two positions/sizes instead
 * of just popping in. Browsers without support simply ignore all of this
 * and navigate normally — it's a progressive enhancement.
 */
export default function ViewTransitionStyles() {
  return (
    <GlobalStyles
      styles={{
        "@keyframes vt-fade-out": {
          to: { opacity: 0, transform: "scale(0.985)" },
        },
        "@keyframes vt-fade-in": {
          from: { opacity: 0, transform: "scale(1.015)" },
          to: { opacity: 1, transform: "scale(1)" },
        },
        "::view-transition-old(root)": {
          animation: "180ms cubic-bezier(0.4, 0, 1, 1) both vt-fade-out",
        },
        "::view-transition-new(root)": {
          animation: "260ms cubic-bezier(0, 0, 0.2, 1) both vt-fade-in",
        },
        "::view-transition-group(*)": {
          animationDuration: "360ms",
          animationTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        },
      }}
    />
  );
}
